import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiCustom from "../../utils/ApiCustom";

export const fetchRegistration = createAsyncThunk(
  "registration/fetchRegistration",
  async () => {
    const response = await apiCustom.get("eventRegistration-show");
    return response.data?.data?.data;
  }
);

export const deleteRegistration = createAsyncThunk(
  "registration/deleteRegistration",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCustom.delete(
        `/eventRegistration-delete/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);

const registrationSlice = createSlice({
  name: "registrations",
  initialState: {
    coupons: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRegistration.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchRegistration.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.registrations = action.payload;
      })
      .addCase(fetchRegistration.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(deleteRegistration.fulfilled, (state) => {
        state.status = "idle";
      });
  },
});

export default registrationSlice.reducer;
